module.exports = __webpack_public_path__ + "1_0_65/img/The Shard.c6b7360d.jpg";